import type { RegistrationProductWaitinglistPriorityRulesPlugin } from '@adornis/buchungsheld-db/db-plugins.js';

export const defaultRegistrationProductWaitinglistPriorityRulesPlugin: RegistrationProductWaitinglistPriorityRulesPlugin =
  {
    id: 'registration::product-waitinglist-priority-rules::default',
    type: 'registration::product-waitinglist-priority-rules',
    getRuleKinds() {
      return [];
    },
    blockTimeForLowPriorityInDays: 0,
  };
